export default __webpack_public_path__ + "static/media/star_current.2bfe78c5.svg";